import React from 'react';
import * as cls from './key-benefits.module.css';
import { Typography } from '../../../ui/components/typography';
import { Section } from '../../../ui/components/section';
import { IMG_PATH } from '../../../constants';

export const KeyBenefits = () => {
  return (
    <Section backgroundContrast>
      <Typography as="h1" tag="h2">
        Key Benefits
      </Typography>

      <div className={cls.key__benefits__wrapper}>
        <div className={cls.key__benefits__item}>
          <img
            alt="Standby alerts to cut wasted energy"
            src={`${IMG_PATH}/amazon-shop/key-benefits-1.png`}
          />
          <Typography as="h4">Keep Track of Your Energy Use</Typography>
          <Typography>
            See exactly how much electricity you’re using - live.
            <br />
            Spot unusual spikes and get a better handle on what’s driving your
            bill.
          </Typography>
        </div>

        <div className={cls.key__benefits__item}>
          <img
            alt="Appliance-level insights with NILM"
            src={`${IMG_PATH}/amazon-shop/key-benefits-2.png`}
          />
          <Typography as="h4">
            Cut Your Bill by Finding What’s Wasting Energy
          </Typography>
          <Typography>
            Find out which appliances use the most - and when.
            <br />
            Make small, informed changes that could save you money each month.
          </Typography>
        </div>

        <div className={cls.key__benefits__item}>
          <img
            alt="Peer to peer comparison of energy consumption"
            src={`${IMG_PATH}/amazon-shop/key-benefits-3.png`}
          />
          <Typography as="h4">See How You Compare to Similar Homes</Typography>
          <Typography>
            Check how your energy use stacks up - and where you could do better.
            <br />
            Get easy tips and alerts to help you waste less and bring your usage
            down.
          </Typography>
        </div>
      </div>
    </Section>
  );
};
